import { render, staticRenderFns } from "./BulletPoint.vue?vue&type=template&id=0015034f"
import script from "./BulletPoint.vue?vue&type=script&lang=js"
export * from "./BulletPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports